import { Validation } from '@vuelidate/core';
import { Ref, watch } from 'vue';

export function useVuelidateTouchWatcher<T>(vuelidate: Ref<Validation<any, T>>, fields: [keyof T, Ref<any>][]) {
  fields.forEach(([key, ref]) => {
    watch(ref, (newValue: any, oldValue: any) => {
      if (newValue !== oldValue && vuelidate.value[key]) {
        vuelidate.value[key].$touch();
      }
    });
  });
}
